const consultationServices = [
  "Guaranteed Maturity Amount Policy",
  "Money Back Policy",
  "Schemes for Children",
  "Exclusive Scheme for Women",
  "Pension Plans",
  "Health Insurance",
  "Cancer Cover Policy",
  "Schemes for NRIs",
  "Cover for Housing & Other Loans",
  "Pure Life Cover - Term Insurance",
  "Income Tax Rebate under Section 80C, 10(10D), 80D",
];

export default consultationServices;
